export const MESSAGES = {
  en: {
    'navbar.brand': 'Infobloom',
    'navbar.searchPlaceholder': 'Search courses...',
    'navbar.search.loading': 'Searching...',
    'navbar.search.empty': 'No courses match your search.',
    'navbar.myLearning': 'My Learning',
    'navbar.teach': 'Teach on Infobloom',
    'navbar.whatsapp': 'Chat with Infobloom on WhatsApp',
    'navbar.login': 'Log in',
    'navbar.signup': 'Sign up',
    'navbar.languageTitle': 'Language',

    'home.creator.title': 'Become a course creator on Infobloom',
    'home.creator.desc': 'Share your expertise, create courses, and earn money. Join our community of instructors and reach learners worldwide.',
    'home.creator.cta': 'Chat with us on WhatsApp to get started',
    'home.creator.button': 'Become a course creator',

    'home.hero.title': 'Learn with Infobloom',
    'home.hero.desc': 'Expert-led courses and certifications built for real-world impact. One place to grow your career, at your pace.',
    'home.hero.start': 'Start learning',
    'home.hero.explore': 'Explore courses',
    'home.popular.title': 'Popular courses',
    'home.trending.title': 'Trending courses',
    'home.courses.loading': 'Loading courses…',
    'home.courses.empty': 'No courses available yet.',
    'home.courses.error': 'Could not load courses. Please refresh the page.',
    'home.testimonials.title': 'Join others transforming their lives through learning.',
    'home.cert.title': 'Get certified by Infobloom',
    'home.cert.subtitle': 'Get certified and get ahead in your career',
    'home.trusted.text': 'Trusted by over 15,000 companies and millions of learners around the world.',

    'login.title': 'Log in to continue your learning journey',
    'login.email': 'Email',
    'login.password': 'Password',
    'login.continue': 'Continue',
    'login.dontHaveAccount': "Don't have an account?",
    'login.signupLink': 'Sign up',
    'login.loadingAria': 'Logging in',

    'signup.title': 'Sign up with email',
    'signup.fullName.placeholder': 'Full name',
    'signup.email.placeholder': 'Email',
    'signup.password.placeholder': 'Password (min 8 characters)',
    'signup.confirmPassword.placeholder': 'Confirm password',
    'signup.marketingLabel': 'Send me special offers, personalized recommendations, and learning tips.',
    'signup.continue': 'Continue',
    'signup.loadingAria': 'Creating account',
    'signup.terms.prefix': 'By signing up, you agree to our',
    'signup.terms.terms': 'Terms of Use',
    'signup.terms.and': 'and',
    'signup.terms.privacy': 'Privacy Policy',
    'signup.alreadyHaveAccount': 'Already have an account?',
    'signup.loginLink': 'Log in',

    'mylearning.title': 'My Learning',
    'mylearning.continueSection': 'Continue learning',
    'mylearning.allCourses': 'All my courses',
    'mylearning.courses': 'My courses',
    'mylearning.empty': "You haven’t enrolled in any courses yet.",
    'mylearning.browse': 'Browse courses',
    'mylearning.completed': 'Completed',
    'mylearning.loading': 'Loading your courses…',
    'mylearning.error': 'Could not load your courses. Please refresh the page.',

    'profile.title': 'Profile and Settings',
    'profile.info.title': 'Profile info',
    'profile.enrolled.title': 'Enrolled courses',
    'profile.certificates.title': 'Certificates',
    'profile.certificates.viewLink': 'View my certificates',
    'profile.password.title': 'Password and security',
    'profile.password.description': 'Change your password and manage security settings.',
    'profile.password.changeButton': 'Change password',
    'profile.password.current': 'Current password',
    'profile.password.new': 'New password',
    'profile.password.confirm': 'Confirm new password',
    'profile.password.save': 'Save password',
    'profile.password.loading': 'Updating password…',
    'profile.password.success': 'Password updated successfully.',

    'generic.loading': 'Loading…',
  },

  es: {
    'navbar.brand': 'Infobloom',
    'navbar.searchPlaceholder': 'Buscar cursos...',
    'navbar.search.loading': 'Buscando...',
    'navbar.search.empty': 'Ningún curso coincide con tu búsqueda.',
    'navbar.myLearning': 'Mi aprendizaje',
    'navbar.teach': 'Enseña en Infobloom',
    'navbar.whatsapp': 'Chatea con Infobloom por WhatsApp',
    'navbar.login': 'Iniciar sesión',
    'navbar.signup': 'Registrarse',
    'navbar.languageTitle': 'Idioma',

    'home.creator.title': 'Conviértete en creador de cursos en Infobloom',
    'home.creator.desc': 'Comparte tu experiencia, crea cursos y gana dinero. Únete a nuestra comunidad de instructores y llega a estudiantes de todo el mundo.',
    'home.creator.cta': 'Chatea con nosotros por WhatsApp para comenzar',
    'home.creator.button': 'Ser creador de cursos',

    'home.hero.title': 'Aprende con Infobloom',
    'home.hero.desc': 'Cursos y certificaciones guiados por expertos para un impacto real. Un solo lugar para hacer crecer tu carrera, a tu ritmo.',
    'home.hero.start': 'Comenzar a aprender',
    'home.hero.explore': 'Explorar cursos',
    'home.popular.title': 'Cursos populares',
    'home.trending.title': 'Cursos en tendencia',
    'home.courses.loading': 'Cargando cursos…',
    'home.courses.empty': 'Todavía no hay cursos disponibles.',
    'home.courses.error': 'No se pudieron cargar los cursos. Actualiza la página.',
    'home.testimonials.title': 'Únete a quienes están transformando sus vidas a través del aprendizaje.',
    'home.cert.title': 'Obtén certificación con Infobloom',
    'home.cert.subtitle': 'Certifícate y avanza en tu carrera',
    'home.trusted.text': 'Confiado por más de 15.000 empresas y millones de estudiantes en todo el mundo.',

    'login.title': 'Inicia sesión para continuar tu aprendizaje',
    'login.email': 'Correo electrónico',
    'login.password': 'Contraseña',
    'login.continue': 'Continuar',
    'login.dontHaveAccount': '¿No tienes una cuenta?',
    'login.signupLink': 'Regístrate',
    'login.loadingAria': 'Iniciando sesión',

    'signup.title': 'Regístrate con correo electrónico',
    'signup.fullName.placeholder': 'Nombre completo',
    'signup.email.placeholder': 'Correo electrónico',
    'signup.password.placeholder': 'Contraseña (mínimo 8 caracteres)',
    'signup.confirmPassword.placeholder': 'Confirmar contraseña',
    'signup.marketingLabel': 'Envíame ofertas especiales, recomendaciones personalizadas y consejos de aprendizaje.',
    'signup.continue': 'Continuar',
    'signup.loadingAria': 'Creando cuenta',
    'signup.terms.prefix': 'Al registrarte, aceptas nuestros',
    'signup.terms.terms': 'Términos de uso',
    'signup.terms.and': 'y',
    'signup.terms.privacy': 'Política de privacidad',
    'signup.alreadyHaveAccount': '¿Ya tienes una cuenta?',
    'signup.loginLink': 'Inicia sesión',

    'mylearning.title': 'Mi aprendizaje',
    'mylearning.continueSection': 'Continuar aprendiendo',
    'mylearning.allCourses': 'Todos mis cursos',
    'mylearning.courses': 'Mis cursos',
    'mylearning.empty': 'Aún no te has inscrito en ningún curso.',
    'mylearning.browse': 'Explorar cursos',
    'mylearning.completed': 'Completados',
    'mylearning.loading': 'Cargando tus cursos…',
    'mylearning.error': 'No se pudieron cargar tus cursos. Actualiza la página.',

    'profile.title': 'Perfil y configuración',
    'profile.info.title': 'Información del perfil',
    'profile.enrolled.title': 'Cursos inscritos',
    'profile.certificates.title': 'Certificados',
    'profile.certificates.viewLink': 'Ver mis certificados',
    'profile.password.title': 'Contraseña y seguridad',
    'profile.password.description': 'Cambia tu contraseña y administra la seguridad.',
    'profile.password.changeButton': 'Cambiar contraseña',
    'profile.password.current': 'Contraseña actual',
    'profile.password.new': 'Nueva contraseña',
    'profile.password.confirm': 'Confirmar nueva contraseña',
    'profile.password.save': 'Guardar contraseña',
    'profile.password.loading': 'Actualizando contraseña…',
    'profile.password.success': 'Contraseña actualizada correctamente.',

    'generic.loading': 'Cargando…',
  },
};

export function translate(langCode, key) {
  const lang = MESSAGES[langCode] || MESSAGES.en;
  if (lang[key]) return lang[key];
  if (MESSAGES.en[key]) return MESSAGES.en[key];
  return key;
}

